import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../../services/jrni/api.service';

/**
 * Shown when the Civica eStore reports a failed payment (SRPO-169, ported from
 * the Solihull ceremonies app). The booking already exists (created post-basket
 * before the redirect), so the visitor can either retry the same eStore URL or
 * abandon, which cancels the booking and restarts the journey.
 */
@Component({
  selector: 'app-estore-fail',
  templateUrl: './estore-fail.component.html',
  styleUrls: ['./estore-fail.component.scss'],
})
export class EstoreFailComponent implements OnInit {
  estoreError = 'Your payment has not been successful';

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.spinner.hide();
    try {
      const err = JSON.parse(localStorage.getItem('estoreError'));
      if (err) {
        this.estoreError = err;
      }
    } catch (err) {
      console.error(err);
    }
  }

  retry() {
    const url = JSON.parse(localStorage.getItem('estoreUrl'));
    if (url) {
      window.location.href = url;
    }
  }

  async restartJourney() {
    this.spinner.show();

    localStorage.removeItem('estoreUrl');
    localStorage.removeItem('estoreError');

    try {
      const booking = JSON.parse(localStorage.getItem('booking'));
      if (booking) {
        await this.apiService.cancelMultiBookings(
          booking.company_id,
          booking.id
        );
      }
    } catch (err) {
      console.error(err);
    }
    localStorage.removeItem('booking');
    this.spinner.hide();

    if (sessionStorage.getItem('journey')) {
      this.router.navigate(['start/' + sessionStorage.getItem('journey')]);
    } else {
      this.router.navigate(['/start']);
    }
  }

  // puts back below next when on a mobile device
  mobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }
}
